var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "release"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2501 3.41257C10.5163 3.1171 9.73154 2.96904 8.94056 2.97686C8.14958 2.98467 7.36788 3.14821 6.6401 3.45812C5.91232 3.76804 5.25271 4.21826 4.69893 4.7831C4.14515 5.34793 3.70805 6.01631 3.41257 6.75007C2.81583 8.23197 2.83222 9.89022 3.45812 11.36C4.08402 12.8299 5.26817 13.9908 6.75007 14.5876M6.75007 11.2501V15.0001H3.00007M13.875 5.25V5.25938M15 8.25V8.25938M14.625 11.25V11.2594M12.75 13.8656V13.875M9.75 15.0001V15.0094",
    stroke: "#37456C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.0b84ee316c1efde7ee0c90b7328b0c27.svg";
export { ForwardRef as ReactComponent };